import BrandPerformance from "./brand-performance";

export default BrandPerformance;
